import {useCallback, useState} from 'react';
import {commitTicketingMutation} from '../../../graphql/forecastRelay';
import RegenerateTicketAiSummaryMutation from '../../../../../mutations/ticketing/tickets/regenerateTicketAiSummaryMutation';

interface Options {
	onCompleted?: () => void;
	onError?: (error: Error) => void;
}

// ACC-297: triggers a synchronous regenerate. Unlike useDismissSuggestedAction we
// also surface `error` so the blocks can render the friendly rate-limit / failure
// message (AC #6) — the backend's 429 message propagates through the mutation.
export function useRegenerateAiSummary(options?: Options) {
	const [inFlight, setInFlight] = useState(false);
	const [error, setError] = useState<Error | null>(null);

	const regenerate = useCallback(
		(ticketId: string) => {
			setInFlight(true);
			setError(null);
			commitTicketingMutation(
				RegenerateTicketAiSummaryMutation,
				{ticketId},
				() => {
					setInFlight(false);
					options?.onCompleted?.();
				},
				err => {
					const e = err instanceof Error ? err : new Error(String(err));
					setInFlight(false);
					setError(e);
					options?.onError?.(e);
				}
			);
		},
		[options]
	);

	return {regenerate, inFlight, error};
}
